"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _webauth = _interopRequireDefault(require("@ozwol/webauth"));

var _FormRegistration = _interopRequireDefault(require("./forms/FormRegistration"));

var _FormEmailValidation = _interopRequireDefault(require("./forms/FormEmailValidation"));

var _FormLogin = _interopRequireDefault(require("./forms/FormLogin"));

var _FormNewPassword = _interopRequireDefault(require("./forms/FormNewPassword"));

var _FormNewPasswordNoCode = _interopRequireDefault(require("./forms/FormNewPasswordNoCode"));

var _FormForgotPassword = _interopRequireDefault(require("./forms/FormForgotPassword"));

var _FormSetName = _interopRequireDefault(require("./forms/FormSetName"));

var _FormSuccess = _interopRequireDefault(require("./forms/FormSuccess"));

var _OzLogo = _interopRequireDefault(require("./../OzLogo/OzLogo.js"));

var _OzContainer = _interopRequireDefault(require("./../OzContainer/OzContainer.js"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzAuthenticator__Wrapper",
  componentId: "sc-1wft4ev-0"
})(["\n"]);

var OzAuthenticator = function OzAuthenticator(_ref) {
  var _ref$entryPoint = _ref.entryPoint,
      entryPoint = _ref$entryPoint === void 0 ? "login" : _ref$entryPoint,
      _ref$enableRegistrati = _ref.enableRegistration,
      enableRegistration = _ref$enableRegistrati === void 0 ? true : _ref$enableRegistrati,
      _ref$requiredGroup = _ref.requiredGroup,
      requiredGroup = _ref$requiredGroup === void 0 ? null : _ref$requiredGroup,
      userPoolId = _ref.userPoolId,
      clientId = _ref.clientId,
      region = _ref.region,
      _ref$identityPoolId = _ref.identityPoolId,
      identityPoolId = _ref$identityPoolId === void 0 ? null : _ref$identityPoolId,
      onSuccess = _ref.onSuccess;

  var _useState = (0, _react.useState)(new _webauth.default({
    userPoolId: userPoolId,
    clientId: clientId,
    region: region,
    identityPoolId: identityPoolId
  })),
      OzAuthService = _useState[0];

  var _useState2 = (0, _react.useState)(entryPoint),
      page = _useState2[0],
      setPage = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      error = _useState3[0],
      setError = _useState3[1];

  var _useState4 = (0, _react.useState)(null),
      email = _useState4[0],
      setEmail = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      sessionUser = _useState5[0],
      setSessionUser = _useState5[1];

  var responseHandler = function responseHandler(response) {
    switch (response.action) {
      case "registration":
        registration(response.params.email, response.params.password1, response.params.password2, response.params.givenName, response.params.familyName, response.params.locale);
        break;

      case "email-validation":
        setEmailValidation(response.params.email, response.params.code);
        break;

      case "login":
        login(response.params.email, response.params.password);
        break;

      case "new-password":
        setNewPassword(response.params.password1, response.params.password2, response.params.code);
        break;

      case "new-password-nocode":
        setNewPasswordNoCode(response.params.password1, response.params.password2);
        break;

      case "forgot-password":
        forgotPassword(response.params.email);
        break;
      // case "recover-password":
      //   recoverPassword(response.params.code, response.params.password1, response.params.password2);
      //   break;

      case "navigate":
        setPage(response.params.page);
        break;

      default:
        break;
    }
  };

  var registration = function registration(email, password1, password2, givenName, familyName, locale) {
    setError(null);
    OzAuthService.registration(email, password1, givenName, familyName, locale).then(function (response) {
      if (!response.UserConfirmed) {
        setSessionUser({
          email: email,
          givenName: givenName,
          familyName: familyName
        });
        setPage("email-validation");
      } else {
        setPage("login");
      }
    }).catch(function (error) {
      console.log(error);
      setError(error.message);
    });
  };

  var login = function login(email, password) {
    setError(null);
    OzAuthService.login(email, password).then(function (response) {
      if (!requiredGroup || response.JwtToken["cognito:groups"] && response.JwtToken["cognito:groups"].includes(requiredGroup)) {
        setPage("success");
        onSuccess(response);
      } else {
        setError("Non hai i permessi.");
      }
    }).catch(function (error) {
      switch (error.ChallengeName) {
        case "NEW_PASSWORD_REQUIRED":
          setEmail(email);
          setSessionUser(error.Session);
          setPage("new-password-nocode"); // forgotPassword(email);

          break;

        default:
          setError(error.message);
          break;
      }
    });
  };

  var setEmailValidation = function setEmailValidation(email, code) {
    setError(null);
    OzAuthService.emailValidation(email, code).then(function (response) {
      setPage("login");
    }).catch(function (response) {
      console.log(response);
      setError(response.error.message);
    });
  };

  var forgotPassword = function forgotPassword(email) {
    setError(null);
    OzAuthService.forgotPassword(email).then(function (response) {
      setSessionUser(email);
      setPage("new-password");
    }).catch(function (response) {
      console.log(response);
      setError(response.error.message);
    });
  };

  var setNewPassword = function setNewPassword(password1, password2, code) {
    setError(null);
    OzAuthService.setNewPassword(sessionUser, password1, code).then(function (response) {
      setPage("login"); //success
      // onSuccess(response.data); // ???
    }).catch(function (response) {
      console.log(response);
      setError(response.error.message);
    });
  };

  var setNewPasswordNoCode = function setNewPasswordNoCode(password1, password2) {
    setError(null);
    OzAuthService.newPasswordChallenge(email, password1, sessionUser).then(function (response) {
      if (!requiredGroup || response.JwtToken["cognito:groups"] && response.JwtToken["cognito:groups"].includes(requiredGroup)) {
        setPage("success");
        onSuccess(response);
      } else {
        setError("Non hai i permessi.");
      }
    }).catch(function (response) {
      console.log(response);
      setError(response.error.message);
    });
  }; // const recoverPassword = (code, password1) => {
  //   setError(null);
  //   OzAuthService.recoverPassword(sessionUser, code, password1).then(response => {
  //     if(response.success){
  //       setPage("success");
  //     }else{
  //       setError(response.error.message);
  //     }
  //   }).catch(response => {
  //     console.log(response);
  //     setError(response.error.message);
  //   });
  // };


  return __jsx(Wrapper, null, __jsx(_OzContainer.default, {
    size: "small"
  }, __jsx(_OzLogo.default, {
    height: "20px"
  }), __jsx("br", null), __jsx("br", null), page === "registration" && enableRegistration ? __jsx(_FormRegistration.default, {
    onConfirm: function onConfirm(response) {
      return responseHandler(response);
    },
    error: error
  }) : page === "email-validation" && sessionUser ? __jsx(_FormEmailValidation.default, {
    sessionUser: sessionUser,
    onConfirm: function onConfirm(response) {
      return responseHandler(response);
    },
    error: error
  }) : page === "login" ? __jsx(_FormLogin.default, {
    enableRegistration: enableRegistration,
    onConfirm: function onConfirm(response) {
      return responseHandler(response);
    },
    error: error
  }) : page === "set-name" && sessionUser ? __jsx(_FormSetName.default, {
    onConfirm: function onConfirm(response) {
      return responseHandler(response);
    },
    error: error
  }) : page === "forgot-password" ? __jsx(_FormForgotPassword.default, {
    onConfirm: function onConfirm(response) {
      return responseHandler(response);
    },
    error: error
  }) : page === "new-password" && sessionUser ? __jsx(_FormNewPassword.default, {
    sessionUser: sessionUser,
    onConfirm: function onConfirm(response) {
      return responseHandler(response);
    },
    error: error
  }) : page === "new-password-nocode" && sessionUser ? __jsx(_FormNewPasswordNoCode.default, {
    sessionUser: sessionUser,
    onConfirm: function onConfirm(response) {
      return responseHandler(response);
    },
    error: error
  }) // : page === "recover-password" ?
  //   <FormRecoverPassword
  //     sessionUser={sessionUser}
  //     onConfirm={(response) => responseHandler(response)}
  //     error={error}
  //   />
  : page === "success" ? __jsx(_FormSuccess.default, {
    onConfirm: function onConfirm(response) {
      return responseHandler(response);
    }
  }) : __jsx(_react.default.Fragment, null, "error")));
};

var _default = OzAuthenticator;
exports.default = _default;